<template>
  <div class="animated fadeIn">
    <DateModal
      modalID="turn_around_time"
      :fetchData="fetchData"
      :dateFrom="dateFrom"
      :dateTo="dateTo"
      @date-picker-modal-emit="onDatePickerModalEmit"
    ></DateModal>
    <b-row>
      <b-col lg="12">
        <b-card class="citiesBar" header="Shipped">
          <div
            slot="header"
            style="display:flex; justify-content: space-between;"
          >
            <HeaderTitle
              title="Turn Around Time Analytics"
              :dateFrom="
                from(dateFrom)
                  ? $formatUSDate(from(dateFrom))
                  : $formatUSDate(dateFrom)
              "
              :dateTo="
                to(dateTo) ? $formatUSDate(to(dateTo)) : $formatUSDate(dateTo)
              "
            ></HeaderTitle>
            <HeaderControl
              :showFullscreenIcon="true"
              :showDateIcon="true"
              :showDownloadPdfIcon="true"
              @emit-fullscreen="toggleFullScreen"
              @emit-date="modalDateEvent"
              @emit-pdf-download="downloadPDF"
            ></HeaderControl>
          </div>
          <div class="chart-wrapper">
            <LoadingCard v-if="loadingTopLocations"></LoadingCard>
            <highcharts
              ref="citiesRef"
              v-else
              :options="barOptions"
              class="chart"
              :constructor-type="'chart'"
            ></highcharts>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Datepicker from "vuejs-datepicker";
import router from "../../../router";
import DateModal from "../../../components/shared/DateModal.vue";
import HeaderTitle from "../../../components/shared/HeaderTitle.vue";
import HeaderControl from "../../../components/shared/HeaderControl.vue";
import LoadingCard from "../../../components/shared/LoadingCard.vue";
import Highcharts from "highcharts";
import exporting from "highcharts/modules/exporting";
import { TurnAroundTimeChart } from "../../../utils/ChartProps";
import { from, isUserLoggedIn, to } from "../../../utils/Utils";
exporting(Highcharts);
export default {
  props: ["location", "productGroup", "type", "date_from", "date_to", "prg"],
  name: "TurnAroundTime",
  components: {
    highcharts: Chart,
    Datepicker,
    DateModal,
    HeaderTitle,
    HeaderControl,
    LoadingCard,
    Highcharts
  },
  data: () => {
    return {
      from: from,
      to: to,
      fullscreen: false,
      locationParam: "",
      productGroupParam: "",
      dateFrom: "",
      dateTo: "",
      title: "",
      loading: true,
      shippedModal: false,
      loadingTopLocations: false,
      barOptions: {},
      data: [],
      fields: [
        { key: "Power Supply", label: "Power Supply" },
        { key: "Meter", label: "Meter" },
        { key: "Line Gear", label: "Line Gear" },
        { key: "Transponder", label: "Transponder" },
        { key: "Fiber Gear", label: "Fiber Gear" }
      ]
    };
  },
  methods: {
    onDatePickerModalEmit(changedDateFrom, changedDateTo) {
      this.dateFrom = changedDateFrom;
      this.dateTo = changedDateTo;
    },
    top10AllDataEmit(disabledAll) {
      this.showAll = disabledAll;
      this.fetchData();
    },
    modalDateEvent() {
      this.exitFullscreen();
      this.$bvModal.show("turn_around_time");
    },
    exitFullscreen() {
      if (!this.fullscreen) {
        return;
      } else {
        this.toggleFullScreen();
      }
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".citiesBar"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.citiesRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.citiesRef.chart.options.chart.height = 400;
      }
      this.$refs.citiesRef.chart.reflow();
    },
    fetchData() {
      this.loadingTopLocations = true;
      let params = {
        date_from: this.from(this.dateFrom),
        date_to: this.to(this.dateTo)
      };
      this.$http
        .get("api/charts/tat.php", {
          params
        })
        .then(
          res => {
            this.data = res.data;
            this.loading = false;
            let xAxis = [];
            let yAxis = [];
            var myData = res.data[0];
            var sortable = [];
            for (var type in myData) {
              sortable.push([type, myData[type]]);
            }
            sortable.sort((a, b) => (parseInt(a[1]) > parseInt(b[1]) ? -1 : 1));
            sortable.forEach(obj => {
              xAxis.push(obj[0]);
              yAxis.push(parseFloat(obj[1]));
            });
            this.barOptions.xAxis.categories = xAxis;
            this.barOptions.series[0].data = yAxis;
            this.loadingTopLocations = false;
          },
          err => {
            console.log(err);
          }
        );
    },
    downloadPDF() {
      this.$refs.citiesRef.chart.options.title.text =
        "Turn Around Time | " +
        (this.from(this.dateFrom) ? this.from(this.dateFrom) : this.dateFrom) +
        " - " +
        (this.to(this.dateTo) ? this.to(this.dateTo) : this.dateTo);

      this.$refs.citiesRef.chart.options.title.style.display = "block";
      this.$refs.citiesRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";

      this.$refs.citiesRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });
      this.$refs.citiesRef.chart.exportChart({
        type: "application/pdf",
        filename:
          "TAT-" +
          (this.from(this.dateFrom)
            ? this.from(this.dateFrom)
            : this.dateFrom) +
          "-" +
          (this.to(this.dateTo) ? this.to(this.dateTo) : this.dateTo)
      });

      this.$refs.citiesRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
    }
  },
  mounted() {
    isUserLoggedIn(router);
    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.barOptions = TurnAroundTimeChart();
    this.fetchData();
  }
};
</script>
<style>
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
.highcharts-exporting-group {
  display: none !important;
}
</style>
